import { useRouter } from "next/router";
import { useLocale } from "hooks";
import { Loading, NewPagination } from "components";
import clsx from "clsx";
import { FaqParentItem } from ".";
import { useEffect, useRef, useState } from "react";
import { ApiService } from "services/serverInClient";
import { normalizeBooks } from "utils/normalizer";
import NoContent from "components/NoContent/NoContent";

const SIZE = 4;

function BookComponent({ data }) {
  const { isRTL } = useLocale();
  const router = useRouter();

  const [list, setList] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const firstTimeRef = useRef<boolean>(true);

  useEffect(() => {
    setList(data?.books || []);
  }, []);

  const onPageChange = ({ selected }) => {
    let url = `/books/${router.query.slug[0]}`;
    if (router.query.slug[1]) {
      url = url + `/${router.query.slug[1]}`;
    }
    url = `${url}?page=${selected + 1}`;
    router.push(url, undefined, { shallow: true });
  };

  useEffect(() => {
    if (!firstTimeRef.current) {
      (async () => {
        try {
          setIsLoading(true);
          const apiService = new ApiService(router.locale);
          const page = Number.isNaN(router.query?.page)
            ? 1
            : +(router.query.page || 1);

          const result = await apiService.getBooks(
            {
              size: SIZE,
              offset: (page - 1) * SIZE,
              tagTreesCode: [router.query?.slug?.[0]],
            },
            { formatter: false }
          );
          setList(normalizeBooks(result));
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      })();
    } else {
      firstTimeRef.current = false;
    }
  }, [router.query]);
  return (
    <div className="tw-pb-[50px] tw-px-4 md:tw-px-0">
      <h1
        className={clsx(
          "tw-text-[#344456] tw-font-bold tw-text-base tw-border-solid tw-border-y-0 tw-border-[#007FAC] tw-mt-[50px]",
          {
            "tw-border-l-0 tw-border-r-4 tw-pr-2.5": isRTL,
            "tw-border-r-0 tw-border-l-4 tw-pl-2.5": !isRTL,
          }
        )}
      >
        {data?.title}
      </h1>
      <div className="tw-mt-[30px]">
        {isLoading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-py-20">
            <Loading />
          </div>
        ) : list?.length > 0 ? (
          <FaqParentItem parent={list} title={""} />
        ) : (
          <NoContent />
        )}
        <div className="tw-mt-5">
          <NewPagination
            currentPage={data?.page}
            totalPagesCount={data?.totalPagesCount}
            onPageChange={onPageChange}
            key={isRTL}
          />
        </div>
      </div>
    </div>
  );
}

export default BookComponent;
